import { render, staticRenderFns } from "./DocAcaoEditarRascunho.vue?vue&type=template&id=8fcc239a&scoped=true&lang=pug&"
import script from "./DocAcaoEditarRascunho.vue?vue&type=script&lang=js&"
export * from "./DocAcaoEditarRascunho.vue?vue&type=script&lang=js&"
import style0 from "./DocAcaoEditarRascunho.vue?vue&type=style&index=0&id=8fcc239a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fcc239a",
  null
  
)

export default component.exports